// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2Osbf","range":"MonthRangeSwitch_range__3WIWR","disabled":"MonthRangeSwitch_disabled__4a1g8"};